import React, { Component } from 'react';
import Cookie from 'react-cookies';

import Header from './DefaultLayout/DefaultHeader';
import Contents from './DefaultLayout/DefaultContents';
import Footer from './DefaultLayout/DefaultFooter';
import MapInfoModal from "./modal/MapInfoModal";
import SurveyModal from "./modal/SurveyModal";

import SisModal from "store/sis/sisModal";
import $ from 'jquery';

import * as Service from '../../services/RestAPI';

import "quill/dist/quill.snow.css";
import './index.scss';

class index extends Component {

    state = {
        noticeList: []
    }

    componentDidMount() {
        //this._setVisitInfo(document.referrer)
        this._getNoticeList();
    }

    handleAgreeModal = (ntNo, target) => {
        $(`#noticeModal${ntNo}`).hide();
        if(target === 'cookie') {
            let cookieList = this.state.cookieList ? this.state.cookieList : [];
            cookieList.push(ntNo);
    
            const expires = new Date();
            expires.setDate(expires.getDate() + 1);
            Cookie.save('ntNo', cookieList, {
                expires
            });
    
            this.setState({
                cookieList
            });
        }
    }

    _setVisitInfo = (ref) => {
        $.ajax({
            url: '/api/setVisit',
            data: {
                ref: ref,
                visitCategory: "메인"
            },
            type: 'get',
            success: (res) => {

            },
            error: (err) => {
                console.error(err);
            }

        })
    }

    _getNoticeList = async () => {
        let noticeList = [];

        const noticeCookie = Cookie.load('ntNo');

        await Service.getNoticeList().then(res => {
            console.log(res);
            const date = new Date();
            const nowDate = date.getFullYear() + "-" + appendZeroValue(date.getMonth() + 1) + "-" + date.getDate();

            res.data.forEach(item => {

                const idx = noticeCookie !== undefined ? noticeCookie.indexOf(item.ntNo) : -1;

                if(noticeCookie !== undefined || idx > -1) {
                    return null;
                }

                if(new Date(item.ntEndDt) >= new Date(nowDate)) {
                    noticeList.push(
                        <SisModal
                            id={`noticeModal${item.ntNo}`}
                            key={item.ntNo}
                            className="noticeModal"
                            style={{width: `${item.ntPopWidth}px`, height: `${item.ntPopHeight}px`}}
                            draggable
                            title={item.ntTitle}
                            closeEvent={() => this.handleAgreeModal(item.ntNo)}
                            contents={
                                <div style={{position: "absolute", top: "0", bottom: "0", width: "100%"}}>
                                    <div className="ql-container ql-snow" style={{ border: "0px" }}>
                                        <div style={{position: "absolute", top: "0", bottom: "30px", width: "100%", padding: "10px"}} dangerouslySetInnerHTML={{ __html: item.ntContent }}></div>
                                        <div className="modalFooter" style={{position: "absolute", bottom: "0"}} onClick={() => this.handleAgreeModal(item.ntNo, 'cookie')}>
                                            오늘하루 그만보기
                                        </div>
                                    </div>
                                </div>
                            }
                        />                 
                    )
                }
            });
        })

        console.log(noticeList);

        this.setState({
            noticeList
        });
    }

    render() {
        return (
            <div>
                <div>
                    {
                        this.state.noticeList.length > 0 &&
                        this.state.noticeList.map((item, idx) => {
                            return item
                        })
                    }
                    <Header target={'main'}/>
                    <Contents/>
                    <Footer/>
                </div>
                <div>
                    <MapInfoModal id="mapInfoModal"/>
                    <SurveyModal id="surveyModal"/>
                    
                </div>
            </div>
            
            
        );
    }
}

function appendZeroValue(target) {
	if (target.toString().length === 1) {
		return "0" + target;
	} else {
		return target;
	}
}

export default index;